{
  "version": 1,
  "asset_id": "1cd185f8-aa07-4bc2-a177-cfe227e53693",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/1cd185f8-aa07-4bc2-a177-cfe227e53693/clip-img_2293-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/1cd185f8-aa07-4bc2-a177-cfe227e53693/clip-img_2293-poster-sm.webp",
  "original_filename": "clip-img_2293-poster-sm.webp",
  "size": 9482,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:44Z"
}
